// import update from '#rsu/immutable-update';
import * as Type from './types';
import { User } from '../user/types';
import initialState from './initialState';

// ACTION CREATORS

export function setAuthAction(
    { user, pending }: { user?: User; pending: boolean },
) {
    return {
        type: Type.AuthType.SET_AUTH,
        user,
        pending,
    };
}

export function logoutAction() {
    return {
        type: Type.AuthType.LOGOUT,
    };
}
// REDUCERS

function setAuth(state: Type.AuthState, action: Type.SetAuthAction) {
    const { user, pending } = action;
    const newState = { user, pending };
    return newState;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
function logout(state: Type.AuthState, action: Type.LogoutAction) {
    return initialState;
}

export default function authReducer(
    state = initialState,
    action: Type.AuthActionTypes,
): Type.AuthState {
    switch (action.type) {
        case Type.AuthType.SET_AUTH:
            return setAuth(state, action);
        case Type.AuthType.LOGOUT:
            return logout(state, action);
        default:
            return state;
    }
}
